import {get} from "lodash"
import BaseService from "./Base"
import {ApiKey} from "types/settings/api-key"

class SettingsService extends BaseService {
    async getClientSettings(body, params = {}) {
        const response = await this.post("/v1/client-settings/public/list", body, params)
        return get(response, "data.data", [])
    }

    async getAllowedDocumentFormats() {
        const response = await this.get("/v1/public/users/documents/allowed-formats", {})
        return get(response, "data.data", [])
    }

    async getApiKeys(params = {}): Promise<{total: number; data: ApiKey[]}> {
        const response = await this.post("/v1/settings/api-keys/list", params)
        return get(response, "data", [])
    }

    async getApiKey(keyId: number): Promise<ApiKey> {
        const response = await this.post("/v1/settings/api-keys/detail", {keyId})
        return get(response, "data.data", {})
    }

    async createApiKey(data: Partial<ApiKey>) {
        const response = await this.post("/v1/settings/api-keys/create", data)
        return get(response, "data.data", {})
    }

    async updateApiKey(keyId: number, data: Partial<ApiKey>) {
        const response = await this.post(`/v1/settings/api-keys/edit`, {...data, keyId})
        return get(response, "data.data", {})
    }

    async deleteApiKeys(keyIds: number[]) {
        await this.post(`/v1/settings/api-keys/delete`, {keyIds})
    }
}

export default SettingsService
